import { Component, OnInit, ViewChild, ElementRef, forwardRef, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, AbstractControl, Validators, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { UserService } from '../../../shared/services/user/user.service';
import { JwtHelper } from 'angular2-jwt';
import { PasswordValidation } from './password-validation';

@Component({
  selector: 'app-change-pass',
  templateUrl: './change-pass.component.html',
  styleUrls: ['./change-pass.component.css']
})
export class ChangePassComponent implements OnInit {

  @ViewChild('contentUser') modal: ElementRef;
  changePassForm: FormGroup;
  modalRef: NgbModalRef;
  isSaveButtonDisabled = true;
  currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  currentUserDetail;
  message: string;
  constructor(private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private userService: UserService,
    private jwtHelper: JwtHelper) {
    if (JSON.parse(sessionStorage.getItem('currentUser'))) {
      this.currentUserDetail = this.jwtHelper.decodeToken(this.currentUser.token);
    }
  }

  ngOnInit() {
    this.createForm();
  }
  showModal() {
    this.modalRef = this.modalService.open(this.modal, { windowClass: 'contact-modal' });
  }
  createForm() {
    this.changePassForm = this.formBuilder.group({
      'old_password': [null],
      'new_password': [null],
      'confirmPassword': [null]
    }, {
        validator: PasswordValidation.MatchPassword
      });
  }
  changePass() {
    const formData = {
      'user_id': this.currentUserDetail.userId,
      'password': this.changePassForm.controls['new_password'].value
    };
    if (this.isSaveButtonDisabled) {
      this.isSaveButtonDisabled = false;
      this.userService.changepass(formData).subscribe(message => {
        console.log(message['message']);
        this.modalRef.close();
        this.createForm();
        this.isSaveButtonDisabled = true;
      },
        (error) => {
          this.isSaveButtonDisabled = true;
          console.log('Error while changing password');
        });
    }
  }

  checkPassword(data) {
    console.log(data);
    this.userService.checkpass({ "password": data }).subscribe(message => {
      console.log(message['data'][0]['count']);
      let chkpass = message['data'][0]['count'];
      if (chkpass === 1) {
        this.message = "";
      } else {
        this.message = "InCorrect Password"
      }
    },
      (error) => {
        console.log('password not found');
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shell/header/change-pass/change-pass.component.ts